module.exports = __webpack_public_path__ + "static/media/sinister.64a92397.svg";